SupportBasePresentation = require('./base')
SupportPresenterUtilPresentation = require('./presenter_util')
SupportGetawaysVoucherStatusAndNotesPresentation = require('./getaways_voucher_messages')

class SupportGetawaysVoucherPresenterPresentation extends SupportBasePresentation
	getLookupObject: () ->
		SupportGetawaysVoucherStatusAndNotesPresentation

module.exports = SupportGetawaysVoucherPresenterPresentation
